import request from '@/utils/http';
import { prefix } from '@/utils/prefix';
import { unwrapResponse } from '@/utils/http/types';
import { storageGetItem } from '@/utils/storage';

/** 上传模板 */
export async function uploadTpl(file, params) {
  const formData = new FormData();
  formData.append('file', file);
  if (params?.name) formData.append('name', params.name);
  if (params?.code) formData.append('code', params.code);
  if (params?.category) formData.append('category', params.category);
  if (params?.description) formData.append('description', params.description);
  return unwrapResponse(request.post(`${prefix.tpl}/tpl/upload`, formData));
}

/** 分页查询模板 */
export async function getTplPage(params) {
  return unwrapResponse(request.get(`${prefix.tpl}/tpl/page`, {
    params
  }));
}

/** 获取模板详情 */
export async function getTpl(id) {
  return unwrapResponse(request.get(`${prefix.tpl}/tpl/${id}`));
}

/** 删除模板 */
export async function deleteTpl(id) {
  return unwrapResponse(request.delete(`${prefix.tpl}/tpl/${id}`));
}

/** 下载模板 */
export async function downloadTpl(id, filename) {
  void filename;
  const token = storageGetItem('token') || '';
  const res = await fetch(`${prefix.tpl}/tpl/${id}/download`, {
    method: 'GET',
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {},
    credentials: 'include'
  });
  return res;
}

/** 按模板 id 列出所有变量（不分页） */
export async function getTplFieldList(tplId) {
  return unwrapResponse(request.get(`${prefix.tpl}/field/list`, {
    params: {
      tplId
    }
  }));
}

/** 新增单条变量 */
export async function createTplField(dto) {
  return unwrapResponse(request.post(`${prefix.tpl}/field`, dto));
}

/** 更新变量 */
export async function updateTplField(id, dto) {
  return unwrapResponse(request.patch(`${prefix.tpl}/field/${id}`, dto));
}

/** 删除变量（软删除） */
export async function deleteTplField(id) {
  return unwrapResponse(request.delete(`${prefix.tpl}/field/${id}`));
}

/** 按 flowId 过滤流程绑定（不分页），不传则列出全部 */
export async function getTplFormList(params) {
  return unwrapResponse(request.get(`${prefix.tpl}/form/list`, {
    params
  }));
}

/** 分页查询流程绑定（支持 tplId / code / name 过滤） */
export async function getTplFormPage(params) {
  return unwrapResponse(request.get(`${prefix.tpl}/form/page`, {
    params
  }));
}

/** 新增一条流程绑定 */
export async function createTplForm(dto) {
  return unwrapResponse(request.post(`${prefix.tpl}/form`, dto));
}

/** 更新流程绑定 */
export async function updateTplForm(id, dto) {
  return unwrapResponse(request.patch(`${prefix.tpl}/form/${id}`, dto));
}

/** 删除流程绑定（软删除） */
export async function deleteTplForm(id) {
  return unwrapResponse(request.delete(`${prefix.tpl}/form/${id}`));
}

/** 按业务编码获取模板 content + form fields 快照 */
export async function getTplContentWithFieldsByCode(code) {
  return unwrapResponse(request.get(`${prefix.tpl}/field/${encodeURIComponent(code)}/tpl`));
}

/** 按业务编码 + 可选 userTaskId 提取 formProperty 字段快照 */
export async function getFormPropertiesByUserTask(code, userTaskId) {
  return unwrapResponse(request.get(`${prefix.tpl}/form/${encodeURIComponent(code)}/variables`, {
    params: userTaskId ? {
      userTaskId
    } : undefined
  }));
}

/**
 * 导出 pdf 文件
 * @param formCode
 * @param bizId
 * @returns
 */
export async function exportPdf2(formCode, bizId) {
  return unwrapResponse(request.get(`${prefix.tpl}/form/export`, {
    params: {
      formCode,
      bizId
    }
  }));
}

// 导出 pdf 文件
export async function exportPdf(formCode, bizId) {
  const token = storageGetItem('token') || '';
  const res = await fetch(`${prefix.tpl}/form/export?code=${formCode}&bizId=${bizId}`, {
    method: 'GET',
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {},
    credentials: 'include'
  });
  return res;
}